import React from 'react';
import './index.scss';
import Table from './table';
import BarAndLineChart from './BarAndLineChart';
import SentimentBarChart from './SentimentBarChart';
import HorizontalBarChart from './HorizontalBarChart';

export default function Index(props: any) {
  const {
    tableData,
    chartType,
    height = 285,
    chartData,
    chart,
    type,
  } = props || {};
  if (chartType === 'table')
    return (
      <Table
        {...props}
        records={
          type === 'language_rating' ? chartData?.rating?.tableData : tableData
        }
      ></Table>
    );

  if (chartType === 'sentiment-s-bar')
    return (
      <SentimentBarChart
        {...chart?.sentimentBar}
        {...props}
        height={height}
        chartData={
          type === 'language_rating' ? chartData.rating : chartData.bar
        }
      />
    );

  if (chartType === 'common-bar')
    return (
      <HorizontalBarChart
        {...chart?.commonBar}
        {...props}
        height={height}
        chartData={chartData.bar}
      />
    );

  return (
    <BarAndLineChart
      {...chart?.barAndLine}
      {...props}
      height={height + 18}
      chartData={chartData.timeline}
    />
  );
}
